import { useState } from "react";
import { IItem } from "../../api/types";
import { IncrementQuantityButton } from "./IncrementQuantityButton";
import { usePutItemMutation } from "../../api/putItem.mutation";
import { EditButton } from "./EditButton";
import { DeleteButton } from "./DeleteButton";
import { useDeleteItemMutation } from "../../api/deleteItem.mutation";
import { Stack, Button, Collapse } from "react-bootstrap";
import { WarehouseName } from "../WarehouseComponents/WarehouseName";
import { InfoCircle } from "react-bootstrap-icons";

const formatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC'
}); // 'en-US' for locale

export const ItemTableRow = (props: { item: IItem }) => {
  const { item: inputItem } = props;
  const [item, setItem] = useState(inputItem);
  const [showDetails, setShowDetails] = useState(false);
  const { mutate: putItem } = usePutItemMutation(inputItem.id)
  const { mutate: deleteItem } = useDeleteItemMutation(inputItem.id)
  const updateItem = (updates: Partial<IItem>) => {
    const newItem = { ...item, ...updates }
    putItem(newItem);
    setItem(newItem);
  }

  return <>
    <tr key={item.id}>
      <td>{item.name}</td>
      <td className="d-none d-sm-table-cell"><WarehouseName warehouseId={item.warehouseId} /></td>
      <td>
        <Stack gap={1} direction='horizontal' className="justify-content-center">
          <IncrementQuantityButton item={item} value={-1} update={updateItem} />
          <span>{item.quantity}</span>
          <IncrementQuantityButton item={item} value={1} update={updateItem} />
        </Stack>
      </td>
      <td>
        <Stack gap={1} direction='horizontal'>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setShowDetails(!showDetails)}
          >
            <InfoCircle size={12} />
          </Button>
          <EditButton item={item} update={updateItem} />
          <DeleteButton onClick={() => deleteItem()} />
        </Stack>
      </td>
    </tr>
    {showDetails && (
      <tr>
        <td colSpan={4} className="text-start">
          <div className="p-2 bg-light d-sm-none">
            <strong>Warehouse:</strong> <WarehouseName warehouseId={item.warehouseId} />
          </div>
          {
            item.cost && <div className="p-2 bg-light">
              <strong>Cost:</strong> {item.cost}
            </div>
          }
          {
            item.expiration && <div className="p-2 bg-light">
              <strong>Expiration:</strong> {formatter.format(new Date(item.expiration))}
            </div>
          }
        </td>
      </tr>
    )}
  </>
}